"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useUncontrolledQuantityPicker = useUncontrolledQuantityPicker;
var _react = require("react");
var _constants = require("./constants");
/**
 * @param {UseQuantityPickerInnerProps} Props
 * @private
 */ function useUncontrolledQuantityPicker(props) {
    var id = props.id, initialValue = props.initialValue, loadOnClick = props.loadOnClick, log = props.log, maxValue = props.maxValue, minValue = props.minValue, onChange = props.onChange, setLastIncreased = props.setLastIncreased, triggerClickEvent = props.triggerClickEvent;
    var _ref;
    var _ref1 = _sliced_to_array((0, _react.useState)((_ref = initialValue !== null && initialValue !== void 0 ? initialValue : minValue) !== null && _ref !== void 0 ? _ref : 1), 2), internalValue = _ref1[0], setInternalValue = _ref1[1];
    var onIncrease = (0, _react.useCallback)(function() {
        triggerClickEvent(id);
        setLastIncreased(id);
        if (typeof internalValue !== 'number' || internalValue === (maxValue !== null && maxValue !== void 0 ? maxValue : _constants.DEFAULT_MAX_VALUE)) {
            return;
        }
        setInternalValue(internalValue + 1);
        log('onIncrease:', internalValue + 1);
        onChange === null || onChange === void 0 ? void 0 : onChange(internalValue + 1, id, 'increase');
    }, [
        triggerClickEvent,
        id,
        setLastIncreased,
        internalValue,
        maxValue,
        log,
        onChange
    ]);
    var onDecrease = (0, _react.useCallback)(function() {
        triggerClickEvent(id);
        setLastIncreased('');
        if (typeof internalValue !== 'number' || internalValue === (minValue !== null && minValue !== void 0 ? minValue : _constants.DEFAULT_MIN_VALUE)) {
            return;
        }
        setInternalValue(internalValue - 1);
        log('onDecrease:', internalValue - 1);
        onChange === null || onChange === void 0 ? void 0 : onChange(internalValue - 1, id, 'decrease');
    }, [
        triggerClickEvent,
        id,
        setLastIncreased,
        internalValue,
        minValue,
        log,
        onChange
    ]);
    // in uncontrolled version we use same logic for blur and enter pressed
    var handleInputElement = (0, _react.useCallback)(function(inputValue) {
        var source = 'input-blur';
        var num = Number.parseInt(inputValue, 10);
        if (!Number.isNaN(num) && num >= (minValue !== null && minValue !== void 0 ? minValue : _constants.DEFAULT_MIN_VALUE) && num <= (maxValue !== null && maxValue !== void 0 ? maxValue : _constants.DEFAULT_MAX_VALUE)) {
            setInternalValue(num);
            onChange === null || onChange === void 0 ? void 0 : onChange(num, id, source);
            return;
        }
        var _ref;
        var fallbackValue = (_ref = initialValue !== null && initialValue !== void 0 ? initialValue : minValue) !== null && _ref !== void 0 ? _ref : 1;
        setInternalValue(fallbackValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(fallbackValue, id, source);
    }, [
        id,
        initialValue,
        maxValue,
        minValue,
        onChange
    ]);
    var handleChange = (0, _react.useCallback)(function(param) {
        var currentTarget = param.currentTarget;
        triggerClickEvent(id);
        setLastIncreased('');
        if (currentTarget.value === '' || currentTarget.value === '-') {
            setInternalValue(currentTarget.value);
            return;
        }
        var num = Number.parseInt(currentTarget.value, 10);
        if (Number.isNaN(num)) {
            return;
        }
        if (num >= (minValue !== null && minValue !== void 0 ? minValue : _constants.DEFAULT_MIN_VALUE) && num <= (maxValue !== null && maxValue !== void 0 ? maxValue : _constants.DEFAULT_MAX_VALUE)) {
            setInternalValue(num);
            onChange === null || onChange === void 0 ? void 0 : onChange(num, id, 'input-change');
        }
    }, [
        triggerClickEvent,
        id,
        setLastIncreased,
        minValue,
        maxValue,
        onChange
    ]);
    var handleBlur = (0, _react.useCallback)(function(param) {
        var currentTarget = param.currentTarget;
        triggerClickEvent(id);
        setLastIncreased(id);
        handleInputElement(currentTarget.value);
    }, [
        triggerClickEvent,
        id,
        setLastIncreased,
        handleInputElement
    ]);
    /** Set last increased for newly initiated with value grater than zero.
   * In case that the value is set to zero, on next increase will be set as newly initiated again.
   */ (0, _react.useEffect)(function() {
        if (loadOnClick && typeof internalValue === 'number' && internalValue === 1) {
            setLastIncreased(id);
        }
    }, [
        id,
        internalValue,
        loadOnClick,
        setLastIncreased
    ]);
    return _object_spread_props(_object_spread({}, props), {
        groupValue: 0,
        handleBlur: handleBlur,
        handleChange: handleChange,
        id: id,
        onDecrease: onDecrease,
        onIncrease: onIncrease,
        value: internalValue
    });
} //# sourceMappingURL=useUncontrolledQuantityPicker.js.map
